import { render, staticRenderFns } from "./ChatItemGroup.vue?vue&type=template&id=294fdb8e&"
import script from "./ChatItemGroup.vue?vue&type=script&lang=js&"
export * from "./ChatItemGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports